// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"game-module--wrapper--1-9nz","programPageParralax":"game-module--programPageParralax--3ckMY","overlay":"game-module--overlay--24DMf"};